import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Routes from './Routes';
import { StripeProvider } from './contexts/StripeContext';
import FloatingHelpWidget from './components/help/FloatingHelpWidget';
import { detectUserCountry } from './services/geolocationService';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const initializeLanguage = async () => {
      try {
        const geoData = await detectUserCountry();
        if (geoData?.language && i18n?.language !== geoData?.language) {
          await i18n?.changeLanguage(geoData?.language);
        }
      } catch (error) {
        console.warn('Failed to initialize language:', error);
      }
    };

    initializeLanguage();
  }, [i18n]);

  return (
    <StripeProvider>
      <Routes />
      <FloatingHelpWidget />
    </StripeProvider>
  );
}

export default App;